/**
 * Recursively traverses an object and lowercases all of its values
 * @param payload The object that needs its values lowercased
 * @param keysToSkip A collection of keys where the logic doesn't apply
 */
const lowerCaseValues = (payload: Object, keysToSkip: string[] = []) => {
  if (!payload) {
    return
  }
  return Object.entries(payload).reduce((updated: { [key: string]: any }, [key, value]) => {
    if (keysToSkip.includes(key)) {
      updated[key] = value
      return updated
    }

    const isString = typeof value === 'string'
    const isObject = typeof value === 'object'
    const isArray = Array.isArray(value)

    if (isArray) {
      updated[key] = value.map(val => lowerCaseValues(val, keysToSkip))
      return updated
    }

    if (isObject) {
      updated[key] = lowerCaseValues(value, keysToSkip)
      return updated
    }

    updated[key] = isString ? value.toLowerCase() : value

    return updated
  }, {})
}

export default lowerCaseValues
